import React, { useState, useEffect } from "react";
import { Box, MenuItem, Typography, Divider, Chip, Tab } from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
// import { GetNotification } from "../../../services/dashboard";
// import { toast } from "react-toastify";
import { useAuth } from "../../../authentication/AuthProvider";

const NotificationDropdown = () => {
  const [value, setValue] = React.useState("1");
  const [notifications, setNotifications] = useState([]);
  const [showText, setShowText] = useState(true);
  const auth = useAuth();

  useEffect(() => {
    // Change the state every second or the time given by User.
    const interval = setInterval(() => {
      setShowText((showText) => !showText);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  // const getNotification = async () => {
  //   const response = await GetNotification();
  //   if (response?.status === 200) {
  //     setNotifications(response?.data);
  //   } else {
  //     toast.error("Couldn't getting Notifications.");
  //   }
  // };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <Box sx={{ width: "100%", typography: "body1" }}>
      <Box display="flex" alignItems="center">
        <Typography variant="h4" fontWeight="500">
          Notifications
        </Typography>
        <Box
          sx={{
            ml: 2,
          }}
        >
          <Chip
            size="small"
            label={`${
              // notifications?.epoNotificationResponse?.length +
              // notifications?.ftoNotificationResponse?.length
              auth.notifications?.length
            } New`}
            sx={{
              borderRadius: "6px",
              pl: "5px",
              pr: "5px",
              backgroundColor: (theme) => theme.palette.warning.main,
              color: "#fff",
            }}
          />
        </Box>
      </Box>

      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList
            onChange={handleChange}
            aria-label="Notfication tab"
            variant="fullWidth"
          >
            <Tab
              label="Missing Punch"
              value="1"
              sx={{ whiteSpace: "nowrap" }}
            />
            <Tab
              // label={`EPO (${notifications?.epoNotificationResponse?.length})`}
              label={`EPO (${auth?.notifications?.length})`}
              value="2"
            />
            <Tab
              label={`FTO(0)`}
              // label={`FTO (${notifications?.ftoNotificationResponse?.length})`}
              value="3"
            />
          </TabList>
        </Box>
        <TabPanel value="1">
          <Typography
            variant="h5"
            noWrap
            sx={{
              width: "100",
              display: showText ? "none" : "flex",
              color: "rosybrown",
            }}
          >
            You have Missing Punches
          </Typography>
        </TabPanel>
        {/* <TabPanel value="2">
          {notifications?.epoNotificationResponse?.map((epo) => (
            <Box>
              <MenuItem>
                <Box>
                  <Typography
                    variant="h5"
                    noWrap
                    sx={{
                      width: "120px",
                    }}
                  >
                    EPO ID : {epo?.epoId}
                  </Typography>
                </Box>
                <Chip
                  size="small"
                  label="Attachment Pending"
                  sx={{
                    borderRadius: "6px",
                    pl: "5px",
                    pr: "5px",
                    backgroundColor: (theme) => theme.palette.error.main,
                    color: "#fff",
                  }}
                />
              </MenuItem>
              <Divider
                style={{
                  marginTop: 0,
                  marginBottom: 0,
                }}
              />
            </Box>
          ))}
        </TabPanel> */}
        <TabPanel value="2">
          {auth?.notifications?.map((epo) => (
            <Box>
              <MenuItem>
                <Box>
                  <Typography
                    variant="h5"
                    noWrap
                    // sx={{
                    //   width: "120px",
                    // }}
                  >
                    {/* EPO ID : {epo?.documentId} */}
                    {epo?.message}
                  </Typography>
                </Box>
                {/* <Chip
                  size="small"
                  label="Attachment Pending"
                  sx={{
                    borderRadius: "6px",
                    pl: "5px",
                    pr: "5px",
                    backgroundColor: (theme) => theme.palette.error.main,
                    color: "#fff",
                  }}
                /> */}
              </MenuItem>
              <Divider
                style={{
                  marginTop: 0,
                  marginBottom: 0,
                }}
              />
            </Box>
          ))}
        </TabPanel>
        <TabPanel value="3">
          {notifications?.ftoNotificationResponse?.map((fto) => (
            <Box>
              <MenuItem>
                <Box>
                  <Typography
                    variant="h5"
                    noWrap
                    sx={{
                      width: "180px",
                    }}
                  >
                    {fto?.personName}
                  </Typography>
                  <Typography
                    color="textSecondary"
                    variant="h6"
                    noWrap
                    fontWeight="400"
                    sx={{
                      width: "180px",
                    }}
                  >
                    {fto?.numberOfDays} of days Requested
                  </Typography>
                  {fto?.supervisorApproval === "Approved" && (
                    <Typography
                      color="textSecondary"
                      variant="h6"
                      noWrap
                      fontWeight="400"
                      sx={{
                        width: "180px",
                      }}
                    >
                      Supervisor Approved
                    </Typography>
                  )}
                  {fto?.hrApproval === "Approved" && (
                    <Typography
                      color="textSecondary"
                      variant="h6"
                      noWrap
                      fontWeight="400"
                      sx={{
                        width: "180px",
                      }}
                    >
                      HR Approved
                    </Typography>
                  )}
                </Box>
                <Chip
                  size="small"
                  label={`FTO ${fto?.id}`}
                  sx={{
                    borderRadius: "6px",
                    pl: "5px",
                    pr: "5px",
                    backgroundColor: (theme) => theme.palette.secondary.main,
                    color: "#fff",
                  }}
                />
              </MenuItem>
              <Divider
                style={{
                  marginTop: 0,
                  marginBottom: 0,
                }}
              />
            </Box>
          ))}
        </TabPanel>
      </TabContext>
    </Box>
  );
};

export default NotificationDropdown;
